import { Stack } from '@mui/material'
import React from 'react'

import { TimeRangeInput } from '../../../__generated__/api'
import DatePickerCalendar from '../../../common/components/DateSelect/DatePickerCalendar'
import TimerangeSelect from '../../../common/components/DateSelect/TimerangeSelect'
import { useIsDesktop, useIsTablet } from '../../../common/hooks/useBreakpoint'
import { useSearchEvents } from '../../../xstate/events'
import { useSearchFilterOptions } from '../../../xstate/selectors'
import useSearchCalendar from '../hooks/useSearchCalendar'

const DesktopDateSelect: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isDesktop = useIsDesktop()
  const isTablet = useIsTablet()
  const { selectedDate, setSelectedDate, calendarDataFetcher } = useSearchCalendar()
  const filterOptions = useSearchFilterOptions()
  const { setSearchFilters } = useSearchEvents()

  if (!isDesktop && !isTablet) {
    return null
  }

  const onChange = (timeRange: TimeRangeInput) => {
    setSearchFilters({
      ...filterOptions,
      timeRange: timeRange,
    })
  }

  return (
    <Stack spacing={4}>
      <DatePickerCalendar
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        calendarDataFetcher={calendarDataFetcher}
        variant="small"
      />
      <TimerangeSelect value={filterOptions.timeRange} onChange={onChange} />
    </Stack>
  )
}

export default DesktopDateSelect
